import { Regions } from "src/app/services/feature-access-control/region.service";

export enum MODULES {
  FLOWBOARD = "flowboard",
  CALENDAR_APPOINTMENT_NOTE = "calendar-appointment-note",
  TESSERA_SANITARIA = "tessera-sanitaria",
  FATTURAZIONE_ELETTRONICA = "fatturazione-elettronica",
  SESSION_AUTO_LOCK = "session-auto-lock",
  CUSTOM_RATETABLE = "custom-ratetable",
  WAREHOUSE = "warehouse",
  RICETTA_ELETTRONICA = "ricetta-elettronica",
  ASL_APPARTENENZA = "asl-appartenenza",
  CUSTOMER_SURVEY = "customer-survey",
  CUSTOMER_ADDRESS_REQUIRED = "customer-address-required",
  ENPAV = "enpav",
  REV = "rev",
  VAT_NUMBER = "vat-number",
  TAX_REGISTRATION_NUMBER = "tax-registration-number",
  STAMP_TAX = "stamp-tax",
  TAX_CODE = "tax-code",
  PRINT_LABEL_TAX_INVOICE = "print-label-tax-invoice",
  INVOICE_CUSTOMER_ADDRESS = "invoice-customer-address",
  INVOICE_COMPLETE_DETAILS = "invoice-complete-detail",
  RATETABLE_ITEM_CATEGORIES = "ratetable-item-categories",
  CAMPAIGN = "segmentations",
  SEGMENTATION = "campaigns",
  PROVINCIA_CLIENTE = "provincia-cliente",
  QUOTES_VAT_NUMBER = "quotes-partita-iva",
  QUOTES_FISCAL_CODE = "quotes-fiscal-code",
  MARKETING = "marketing",
  TATTOO = "tattoo"
}

export enum LICENSES {
  ESSENTIAL = "essential",
  REGULAR = "regular",
  ADVANCED = "advanced"
}

const MODULES_BASE_BY_REGION: MODULES[] = [
  MODULES.FLOWBOARD,
  MODULES.CALENDAR_APPOINTMENT_NOTE,
  MODULES.SESSION_AUTO_LOCK,
  MODULES.CUSTOM_RATETABLE,
  MODULES.WAREHOUSE,
  MODULES.CUSTOMER_SURVEY,
  MODULES.REV,
  MODULES.MARKETING
];

export const MODULES_BY_REGION: Record<Regions, Array<MODULES>> = {
  [Regions.IT]: [
    ...MODULES_BASE_BY_REGION,
    MODULES.TESSERA_SANITARIA,
    MODULES.FATTURAZIONE_ELETTRONICA,
    MODULES.RICETTA_ELETTRONICA,
    MODULES.ASL_APPARTENENZA,
    MODULES.ENPAV,
    MODULES.VAT_NUMBER,
    MODULES.STAMP_TAX,
    MODULES.TAX_CODE,
    MODULES.INVOICE_CUSTOMER_ADDRESS,
    MODULES.CUSTOMER_ADDRESS_REQUIRED,
    MODULES.INVOICE_COMPLETE_DETAILS,
    MODULES.PROVINCIA_CLIENTE,
    MODULES.QUOTES_VAT_NUMBER,
    MODULES.QUOTES_FISCAL_CODE,
    MODULES.TATTOO
  ],
  [Regions.FR]: [
    ...MODULES_BASE_BY_REGION,
    MODULES.TAX_CODE,
    MODULES.VAT_NUMBER,
    MODULES.INVOICE_CUSTOMER_ADDRESS,
    MODULES.CUSTOMER_ADDRESS_REQUIRED,
    MODULES.INVOICE_COMPLETE_DETAILS,
    MODULES.RATETABLE_ITEM_CATEGORIES,
    MODULES.PROVINCIA_CLIENTE,
    MODULES.QUOTES_VAT_NUMBER,
    MODULES.QUOTES_FISCAL_CODE
  ],
  [Regions.EN]: [
    ...MODULES_BASE_BY_REGION,
    MODULES.TAX_CODE,
    MODULES.VAT_NUMBER,
    MODULES.INVOICE_CUSTOMER_ADDRESS,
    MODULES.CUSTOMER_ADDRESS_REQUIRED,
    MODULES.INVOICE_COMPLETE_DETAILS,
    MODULES.PROVINCIA_CLIENTE,
    MODULES.QUOTES_VAT_NUMBER,
    MODULES.QUOTES_FISCAL_CODE
  ],
  [Regions.ES]: [
    ...MODULES_BASE_BY_REGION,
    MODULES.TAX_CODE,
    MODULES.VAT_NUMBER,
    MODULES.INVOICE_CUSTOMER_ADDRESS,
    MODULES.CUSTOMER_ADDRESS_REQUIRED,
    MODULES.INVOICE_COMPLETE_DETAILS,
    MODULES.PROVINCIA_CLIENTE,
    MODULES.QUOTES_VAT_NUMBER,
    MODULES.QUOTES_FISCAL_CODE
  ],
  [Regions.AE]: [
    ...MODULES_BASE_BY_REGION,
    MODULES.TAX_REGISTRATION_NUMBER,
    MODULES.PRINT_LABEL_TAX_INVOICE,
    MODULES.PROVINCIA_CLIENTE,
    MODULES.QUOTES_VAT_NUMBER,
    MODULES.QUOTES_FISCAL_CODE
  ],
  [Regions.CH]: [...MODULES_BASE_BY_REGION, MODULES.INVOICE_CUSTOMER_ADDRESS],
  [Regions.KA]: [...MODULES_BASE_BY_REGION]
};

const MODULES_BASE_BY_LICENSE: MODULES[] = [
  MODULES.TESSERA_SANITARIA,
  MODULES.FATTURAZIONE_ELETTRONICA,
  MODULES.RICETTA_ELETTRONICA,
  MODULES.ASL_APPARTENENZA,
  MODULES.ENPAV,
  MODULES.VAT_NUMBER,
  MODULES.TAX_REGISTRATION_NUMBER,
  MODULES.REV,
  MODULES.STAMP_TAX,
  MODULES.TAX_CODE,
  MODULES.PRINT_LABEL_TAX_INVOICE,
  MODULES.INVOICE_CUSTOMER_ADDRESS,
  MODULES.CUSTOMER_ADDRESS_REQUIRED,
  MODULES.INVOICE_COMPLETE_DETAILS,
  MODULES.RATETABLE_ITEM_CATEGORIES,
  MODULES.PROVINCIA_CLIENTE,
  MODULES.QUOTES_VAT_NUMBER,
  MODULES.QUOTES_FISCAL_CODE,
  MODULES.TATTOO
];

export const MODULES_BY_LICENSE: Record<LICENSES, Array<MODULES>> = {
  essential: [...MODULES_BASE_BY_LICENSE, MODULES.SESSION_AUTO_LOCK],
  regular: [
    ...MODULES_BASE_BY_LICENSE,
    MODULES.FLOWBOARD,
    MODULES.CALENDAR_APPOINTMENT_NOTE,
    MODULES.SESSION_AUTO_LOCK,
    MODULES.CUSTOM_RATETABLE,
    MODULES.WAREHOUSE,
    MODULES.CUSTOMER_SURVEY,
    MODULES.CAMPAIGN,
    MODULES.SEGMENTATION,
    MODULES.MARKETING
  ],
  advanced: [
    ...MODULES_BASE_BY_LICENSE,
    MODULES.FLOWBOARD,
    MODULES.CALENDAR_APPOINTMENT_NOTE,
    MODULES.SESSION_AUTO_LOCK,
    MODULES.CUSTOM_RATETABLE,
    MODULES.WAREHOUSE,
    MODULES.CUSTOMER_SURVEY,
    MODULES.CAMPAIGN,
    MODULES.SEGMENTATION,
    MODULES.MARKETING
  ]
};
